import { MediaData } from './media-data';
import { InspectionDefectData } from './inspection-defect-data';
import { InspectionWorkflowStatusEnum } from '../../enum/inspection-workflow-status.enum';
import { StaffSignatureData } from './staff-signature-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ScaffoldInspectionData {
  ScaffoldDiaryId: string;
  OwnerId: string;
  Comments: string;
  Media: { [key: string]: MediaData };
  InspectionOutcomeId: string;
  InspectionTypeId: string;
  InspectionDefects: { [key: string]: InspectionDefectData };
  InspectionWorkflowStatus: InspectionWorkflowStatusEnum;
  When: string;
  InspectorsSignature: StaffSignatureData;
}


